module.exports = "<p>campus-list works!</p>\n"